import { createFileRoute } from '@tanstack/react-router'
import { AuthLayout, ResetPasswordCard } from '@/components/auth-card'
export const Route = createFileRoute('/reset-password')({ component: () => <AuthLayout><ResetPasswordCard /></AuthLayout> })
